import React from 'react';
import { Button, Typography } from '../../components';
import { Circle, Main } from './styled';
import { GeneralContext } from '../../App';

export default function Temporary(props) {
    const { hasPhone, hasTablet } = React.useContext(GeneralContext);
    
    return (
        <Main>
            <Circle>
                <Typography type='h2' style={{ fontSize: hasPhone ? '1.6em' : hasTablet ? '3vw' : '2vw' }}>Deze pagina is in ontwikkeling</Typography>
            </Circle>
            <Button 
                to='/'
                text='Ga terug naar homepage'
            />
        </Main>
    );
}